/*************************************************
 * VirtuOwl
 * EducatorProfileAction.js
 * Copyright © 2018 concertIDC. All rights reserved.
 *************************************************/
import Client from '../../../utils/ClientVOIM';
import { ACTION_TYPES } from '../../../utils/Constants';
import { myLog } from '../../../utils/Utility';
import URL from '../../../utils/URL';

export const getEducatorDetails = (callBack) => {
    return function () {
        Client.get(URL.IM_EDUCATOR.GET_EDUCATOR_DETAILS, null, true)
            .then((response) => {
                callBack(response);
            })
            .catch((error) => {
                myLog('====educator details error===????', error);
                callBack(false);
            });
    };
};

export function educatorProfileUpload(values, callBack) {
    return function (dispatch) {
        Client.put(URL.IM_EDUCATOR.UPDATE_EDUCATOR_PROFILE, values, true)
            .then((response) => {
                myLog('====educator image upload response===::::', response);
                callBack(response);
                dispatch({
                    type: ACTION_TYPES.EDUCATOR.UPDATE_EDUCATOR_PROFILE,
                    payload: response,
                });
            })
            .catch((error) => {
                myLog('====educator image upload error===????', error);
                callBack(false);
            });
    };
}
